import { useQuery } from "@tanstack/react-query";

import { getFinalAssessmentQuestionApiCall } from "./utils.api";

import { finalAssessmentQuestionKeys } from "../../../../redux/services/finalAssessmentQuestion";

export const useGetFinalAssessmentQuestion = (payload) =>{
    const {languageid}= payload;

    return useQuery({
        queryKey: finalAssessmentQuestionKeys.getFinalAssessmentQuestionKeys({languageid}),
        queryFn: () => getFinalAssessmentQuestionApiCall({ languageid }),
    });
}